import { render, staticRenderFns } from "./StandardButtons.vue?vue&type=template&id=814005e0&"
import script from "./StandardButtons.vue?vue&type=script&lang=js&"
export * from "./StandardButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports